import React, { useEffect, useRef, useState } from "react"
import "./style.css"

type TDropdownProps = {
    name:string,
    list:TDropdownSelectedItem[],
    onFilterSelect(selections:TDropdownSelectedItem[]): void,
    size: "S"|"M"
}

export type TDropdownSelectedItem = {
    selected: boolean,
    key: string,
    name: string
}

export const ConfigDropdown = ({name, list, onFilterSelect, size}:TDropdownProps) => {
    const [expanded, setExpanded] = useState<boolean>(false);
    
    var entries = list
    const ref = useRef<HTMLDivElement>(null);

    const onClickOutside = () => {
        setExpanded(false)
    }

    useEffect(() => {
        const handleClickOutside = (event:MouseEvent) => {
          if (ref.current && event.target && !ref.current.contains(event.target as Node)) {
            onClickOutside();
          }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
          document.removeEventListener('click', handleClickOutside, true);
        };
      }, []);
    
    const onClick = () => {
        if(expanded){
            setExpanded(false)
        }else{
            setExpanded(true)
        }
    }

    const getTitle = () => {
        var title = "";
        var first = true;
        for (var entry of entries){
            
            if (entry.selected === true){
                if (first){
                    title = `${entry.name}`
                    first = false;
                } else {
                    title = `${title}, ${entry.name}`
                }
            }
        }
        if (!title){
            title = name
        }

        return title;
    }

    const onSelect = (key:string) => {
        entries = entries.map(entry => {
            if (entry.key === key){
                entry.selected = !entry.selected
            }
            return entry
        })

        onFilterSelect(entries)
    }

    const isSelected = (key:string) => {
        for (var entry of entries){
            if(entry.key === key && entry.selected){
                return "selected"
            }
        }
        return ""
    }

    const isExpanded = () => {
        return expanded ? "expanded" : "";
    }

    

    return (
        <div ref={ref}>
            <div className={`filter width${size} ${isExpanded()}`} onClick={onClick}>
                <span className="filterText widthSInner">{getTitle()}</span>
            </div>
            <div className={`filterContent width${size} ${isExpanded()}`}>
                {list.map(entry => <p onClick={() => onSelect(entry.key)} key={entry.key} className={`filterEntry ${isSelected(entry.key)}`}><span className={`filterCheckbox ${isSelected(entry.key)}`}></span> {entry.name}</p>)}
            </div>
        </div>
    )
}